import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumExportIncotermCode implements BaseEnumType {
  private static allValues: EnumExportIncotermCode[] = []; // make sure this is top-most
  
  public static none = new EnumExportIncotermCode(0, "None", "enum_export_incoterm_code_none");
  public static eXW = new EnumExportIncotermCode(1, "EXW", "enum_export_incoterm_code_e_x_w");
  public static fCA = new EnumExportIncotermCode(2, "FCA", "enum_export_incoterm_code_f_c_a");
  public static fAS = new EnumExportIncotermCode(3, "FAS", "enum_export_incoterm_code_f_a_s");
  public static fOB = new EnumExportIncotermCode(4, "FOB", "enum_export_incoterm_code_f_o_b");
  public static cFR = new EnumExportIncotermCode(5, "CFR", "enum_export_incoterm_code_c_f_r");
  public static cIF = new EnumExportIncotermCode(6, "CIF", "enum_export_incoterm_code_c_i_f");
  public static cIP = new EnumExportIncotermCode(7, "CIP", "enum_export_incoterm_code_c_i_p");
  public static dPU = new EnumExportIncotermCode(8, "DPU", "enum_export_incoterm_code_d_p_u");
  public static dDP = new EnumExportIncotermCode(9, "DDP", "enum_export_incoterm_code_d_d_p");
  public static cPT = new EnumExportIncotermCode(10, "CPT", "enum_export_incoterm_code_c_p_t");
  public static dAP = new EnumExportIncotermCode(11, "DAP", "enum_export_incoterm_code_d_a_p");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumExportIncotermCode.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumExportIncotermCode.none; }
  public isEXW() { return this === EnumExportIncotermCode.eXW; }
  public isFCA() { return this === EnumExportIncotermCode.fCA; }
  public isFAS() { return this === EnumExportIncotermCode.fAS; }
  public isFOB() { return this === EnumExportIncotermCode.fOB; }
  public isCFR() { return this === EnumExportIncotermCode.cFR; }
  public isCIF() { return this === EnumExportIncotermCode.cIF; }
  public isCIP() { return this === EnumExportIncotermCode.cIP; }
  public isDPU() { return this === EnumExportIncotermCode.dPU; }
  public isDDP() { return this === EnumExportIncotermCode.dDP; }
  public isCPT() { return this === EnumExportIncotermCode.cPT; }
  public isDAP() { return this === EnumExportIncotermCode.dAP; }

  public static getValues(): readonly EnumExportIncotermCode[] {
    return EnumExportIncotermCode.allValues;
  }

  public static getValuesExcept0(): readonly EnumExportIncotermCode[] {
    return EnumExportIncotermCode.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumExportIncotermCode {
    const found = EnumExportIncotermCode.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumExportIncotermCode - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumExportIncotermCode): EnumExportIncotermCode {
    const found = name ? EnumExportIncotermCode.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumExportIncotermCode - Value not found: ${ name }`);
    }

    return found;
  }
}